import { render, staticRenderFns } from "./dataGridExpColChoose.vue?vue&type=template&id=5a4f1dd7&"
import script from "./dataGridExpColChoose.vue?vue&type=script&lang=js&"
export * from "./dataGridExpColChoose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/sysButton/setting/dataGridExpColChoose.vue"
export default component.exports